import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, take} from 'rxjs';
import {GlobalConstants} from '../shared/global-constants';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private readonly tokenChangedSubject = new BehaviorSubject<boolean>(localStorage.getItem(GlobalConstants.TOKEN) !== null);
  private readonly tokenChanged$: Observable<boolean> = this.tokenChangedSubject.asObservable();

  constructor() {}

  setToken(token: string): void {
    localStorage.setItem(GlobalConstants.TOKEN, token);
    this.tokenChangedSubject.next(!!token);
  }

  removeToken(): void {
    localStorage.removeItem(GlobalConstants.TOKEN);
    this.tokenChangedSubject.next(false);
  }

  hasToken(): boolean {
    return !!localStorage.getItem(GlobalConstants.TOKEN);
  }

  get waitUntilLoaded$(): Observable<boolean> {
    return this.tokenChanged$.pipe(
      filter(loaded => loaded),
      take(1)
    );
  }
}
